import "./NameStartingWithTheLetterA.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import ANamesGrid from "./sections/ANamesGrid";
import PackagingInsightsNewsletter from "./sections/PackagingInsightsNewsletter";
import Footer from "@/reusable_sections/Footer";
export default function NameStartingWithTheLetterAPage() {
  return <div>
      <Header />
      <OurStory />
      <ANamesGrid />
      <PackagingInsightsNewsletter />
      <Footer />
    </div>;
}